<template>
  <div v-if="isAuthenticated === true">
    <div class="q-pa-md">
      <div id="q-app" style="border-radius: 15px; ">
        <q-table
          :loading="isLoading"
          title=""
          :data="data"
          :columns="columns"
          row-key="name"
          no-data-label="No Result History Found"
          :style="{
            flexgrow: '1',
            fontfamily: 'sans-serif ',
            fontweight: 'bolder',
            fontsize: '24px',
            background: '',
          }"
        >
          <template v-slot:top-right>
            <h6
              style="position: relative;
    left: -167%;
    font-weight: bolder;"
            >
              YOUR PRODUCT DETAILS
            </h6>
           
            <q-input
              :style="{ fontSize: '15px' }"
              dense
              debounce="300"
              placeholder="Search"
              v-model="filter"
              @input="
                (val) => {
                  searchHandler(val);
                }
              "
            >
              <q-icon slot="append" name="search" />
            </q-input>
          </template>

          <template v-slot:header="props">
            <q-tr :props="props">
              <!-- <q-th>
            
          </q-th> -->
              <div
                class="check"
                style="position: relative;top: 3vh;
     font-size:'20px'     visibility: hidden;"
              >
                <!-- <q-radio name="shape" v-model="shape" val="line" size="20px" /> -->
                <q-checkbox dense v-model="teal" color="black" size="2em" />
              </div>
              <q-th
                v-for="col in columns"
                :key="col.name"
                :props="props"
                class="headerText"
                :style="{
                  fontSize: '13px',
                  color: 'black',
                  background: '',
                  position: 'relative',
                  fontWeight: '900',
                }"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props" v-if="props.row.is_delete === false">
              <div
                style="    position: relative;
    top: 2vh;"
              >
              </div>
              <q-td key="name" :props="props">
                {{ props.row.price_watch_details[0]["product_name"] }}
              </q-td>
              <!-- <q-td key="brand" :props="props">
            {{props.row.price_watch_details[0]['brand']}}
          </q-td> -->
              <q-td key="lower_limit" :props="props">
                {{ props.row.price_watch_details[0]["product_lower_limit"] }}
              </q-td>
              <q-td key="upper_limit" :props="props">
                {{ props.row.price_watch_details[0]["product_upper_limit"] }}
              </q-td>
              <!-- <q-td key="selling_price" :props="props">
            {{props.row.price_watch_details[0]['selling_price']}}
          </q-td> -->
              <q-td key="competitors_tracked" :props="props">
                <div>
                  <q-tooltip>
                    Auto-generating your competitor urls, it might take around
                    24 hours to fetch urls.
                  </q-tooltip>
                  <q-btn
                    v-if="
                      props.row.status == 'SUBMITTED' &&
                        props.row.type == 'auto_suggest'
                    "
                    label="Processing.."
                    style="pointer-events:none"
                  >
                  </q-btn>
                </div>

                <div>
                  <q-tooltip>
                    Could not auto-generate urls, please add urls manually by
                    clicking on edit button
                  </q-tooltip>
                  <q-btn
                    v-if="props.row.status == 'FAILED'"
                    class="bg-grey text-white"
                    label="Failed"
                    style="pointer-events:none"
                  ></q-btn>
                </div>

                <p
                  v-if="
                    (props.row.status == 'SUBMITTED' &&
                      props.row.type == 'manual') ||
                      (props.row.status == 'CONFIRMED' &&
                        props.row.type == 'auto_suggest') ||
                      (props.row.status == 'SUBMITTED' &&
                        props.row.type == null)
                  "
                >
                  {{
                    props.row.price_watch_details[0].url_list.filter(function(
                      el
                    ) {
                      return el != "";
                    }).length
                  }}
                </p>
                <!-- <span v-else>{{props.row.status +  props.row.type}}</span> -->

                <q-btn
                  style="background-color:#102689;color:white;"
                  v-if="
                    props.row.status == 'READY' &&
                      props.row.type == 'auto_suggest'
                  "
                  label="Add Now"
                  @click="
                    props.row.pop_up = !props.row.pop_up;
                    props_backup_list =
                      props.row.price_watch_details[0].url_list;
                  "
                ></q-btn>
                <div v-if="props.row.pop_up === true">
                  <q-dialog v-model="props.row.pop_up">
                    <q-card
                      style="min-height: 80vh;width:900px;max-width:1500px"
                    >
                      <q-card-actions>
                        <font-awesome-icon
                          @click="
                            props.row.pop_up = !props.row.pop_up;
                            props.row.price_watch_details[0].url_list = list2.concat(
                              props.row.price_watch_details[0].url_list
                            );
                            is_empty = true;
                            enabled = true;
                            list2 = [];
                          "
                          icon="fa-solid fa-window-close"
                          class="close-icon text-negative"
                        />
                      </q-card-actions>
                      <q-card-section>
                        <div class="text-h5 text-bold text-center">
                          SELECT
                          <span class="autogenerate">AUTOGENERATED</span> URLS
                        </div>
                      </q-card-section>

                      <q-card-section class="scroll">
                        <div class="row">
                          <div class="col-6">
                            <!-- <h6 class="text-center">Draggable 1</h6> -->
                            <div class="left-draggable">
                              <img
                                v-if="is_empty"
                                src="../../assets/drag-drop.webp"
                              />
                              <p class="note" v-if="is_empty">
                                Drag and drop the competitor URLs
                              </p>

                              <draggable
                                class="list-group left-group"
                                :animation="120"
                                :disabled="!enabled"
                                ghost-class="moving-card"
                                :list="list2"
                                group="people"
                                @change="log"
                              >
                                <div
                                  class="list-group-item left-list"
                                  v-for="element in list2"
                                  :key="element"
                                >
                                  <p>
                                    <font-awesome-icon
                                      icon="fa-solid fa-link"
                                      class="icons  q-mx-sm"
                                    />{{ element }}
                                  </p>
                                </div>
                                <p
                                  v-if="max_urls == true"
                                  class="text-negative text-center q-mt-md"
                                >
                                  * Maximum urls reached, you can select only 5
                                  competitor urls
                                </p>
                              </draggable>
                            </div>
                          </div>
                          <div class="col-6 ">
                            <!-- <h6 class="text-center">Draggable 2</h6> -->
                            <draggable
                              class="list-group right-draggable"
                              :animation="120"
                              ghost-class="moving-card"
                              :list="props.row.price_watch_details[0].url_list"
                              group="people"
                              @change="log"
                            >
                              <div
                                class="list-group-item right-list "
                                v-for="element in props.row
                                  .price_watch_details[0].url_list"
                                :key="element"
                              >
                                <p>
                                  <font-awesome-icon
                                    icon="fa-solid fa-link"
                                    class="icons q-mx-sm"
                                  />{{ element }}
                                </p>
                              </div>
                            </draggable>
                          </div>
                        </div>

                        
                      </q-card-section>
                      <div class="submit">
                        <q-btn
                          class="primary"
                          label="SUBMIT"
                          @click="
                            edit_competitor_urls(
                              props.row,
                              list2,
                              props.row.price_watch_details[0].url_list
                            );
                            props.row.pop_up = false;
                            props.row.status = 'CONFIRMED';
                            is_empty = true;
                            enabled = true;
                            list2 = [];
                          "
                        ></q-btn>
                      </div>
                    </q-card>
                  </q-dialog>
                </div>
              </q-td>

              <!-- <q-td key="type" :props="props">
            {{props.row.price_watch_details[0]['type']}}
          </q-td> -->
              <q-td key="edit" :props="props">
                <div v-if="props.row.is_enable === 'True'">
                  <q-btn
                    unelevated
                    v-on:click="edit(props.row)"
                    color="#F5FBFF"
                    label="Edit"
                    size="12px"
                  ></q-btn>
                </div>
                <div v-else>
                  <q-btn
                    outline
                    v-on:click="disable_popup = true"
                    color="grey"
                    label="Edit"
                    size="12px"
                  ></q-btn>
                  <q-btn
                    unelevated
                    v-on:click="edit(props.row)"
                    :style="{
                      'pointer-events':
                        props.row.status === 'SUBMITTED' &&
                        props.row.type === 'auto_suggest'
                          ? 'none'
                          : 'auto',
                    }"
                    color="primary"
                    label="Edit"
                    style="display:none"
                  ></q-btn>
                </div>
                <q-dialog v-model="editing" full-width>
                  <q-card>
                    <q-card-section>
                      <div class="text-h6">
                        Edit Price Watch submitted details
                      </div>
                    </q-card-section>

                    <q-separator></q-separator>

                    <q-card-section>
                      <div class="editdetails">
                        <div class="details">
                          <div class="details-row">
                            <div class="form-control">
                              <label>Product Name</label>
                              <input
                                type="text"
                                v-model="
                                  data[current]['price_watch_details'][0][
                                    'product_name'
                                  ]
                                "
                                readonly
                              />
                            </div>
                            <div class="form-control">
                              <label>Product Tags</label>
                              <input
                                type="text"
                                v-model="
                                  data[current]['price_watch_details'][0][
                                    'product_tags'
                                  ]
                                "
                              />
                            </div>
                          </div>
                          <div class="details-row">
                            <div class="form-control">
                              <label>Lower Boundary of Selling Price</label>
                              <input
                                type="number"
                                v-model="
                                  data[current]['price_watch_details'][0][
                                    'product_lower_limit'
                                  ]
                                "
                              />
                            </div>
                            <div class="form-control">
                              <label>Upper Boundary of Selling Price</label>
                              <input
                                type="number"
                                v-model="
                                  data[current]['price_watch_details'][0][
                                    'product_upper_limit'
                                  ]
                                "
                              />
                            </div>
                          </div>
                          <div class="details-row">
                            <div class="form-control">
                              <label>Your URL</label>
                              <input
                                type="text"
                                v-model="
                                  data[current]['price_watch_details'][0][
                                    'client_url'
                                  ]
                                "
                              />

                              
                            </div>

                           
                            <div class="form-control-text-area">
                              <div class="form-control">
                                <label
                                  style="position: relative;
    right: -12px;"
                                >
                                  Competitor URLs</label
                                >
                                <div class="tags-input-container">
                                  <div
                                    class="tag"
                                    v-for="(tag, index) in data[current][
                                      'price_watch_details'
                                    ][0]['url_list']"
                                    :key="'tag' + index"
                                  >
                                    <!-- <input
                                type="text"
                                v-if="tag != '' "
                                v-model="
                                 tag
                                "
                              /> -->

                                    <span
                                      v-if="activeTag !== index"
                                      @click="activeTag = index"
                                      >{{ tag }}</span
                                    >

                                    <input
                                      v-else
                                      v-model="
                                        data[current]['price_watch_details'][0][
                                          'url_list'
                                        ][index]
                                      "
                                      v-focus
                                      :style="{ width: '520px' }"
                                      @keyup.enter="activeTag = null"
                                      @blur="activeTag = null"
                                    />
                                    <span
                                      @click="
                                        removeTag(
                                          index,
                                          data[current][
                                            'price_watch_details'
                                          ][0]['url_list']
                                        )
                                      "
                                      ><i class="fas fa-times-circle"></i
                                    ></span>
                                  </div>
                                  <input
                                    v-model="tagValue"
                                    @keyup.enter="
                                      addTag(
                                        data[current]['price_watch_details'][0][
                                          'url_list'
                                        ]
                                      )
                                    "
                                  />
                                </div>

                               
                              </div>
                            </div>

              
                          </div>
                          <div class="lab">
                            <label v-if="addType === 'imp'"> Product id</label>
                           
                            <q-card
                              style="background-color: rgb(210 230 250);width: 908px;    position: relative;
    left: 6rem;">
                              <q-card-section>
                                <div class="text-h6">
                                  Smart Pricing Suggestion
                                </div>
                              </q-card-section>

                              <q-card-section class="q-pt-none">
                                <div class="cards">
                                  <div class="deta">
                                    
                                    <div class="inputs">
                                     
                                      <label>My price should be </label>
                                      
                                      <q-btn-dropdown
                                        flat
                                        style="color: black"
                                        class="dropdown"
                                        :label="
                                          data[current][
                                            'price_watch_details'
                                          ][0]['comparision']
                                        "
                                      >
                                        <q-list>
                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['comparision'] = ' LowerThan'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Lower than</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>

                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['comparision'] = 'HigherThan'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Higher than</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>
                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['comparision'] = 'EqualTo'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Equal to</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>
                                        </q-list> </q-btn-dropdown
                                      ><label>the</label>
                                      <q-btn-dropdown
                                        flat
                                        style="color: black"
                                        class="dropdown"
                                        :label="
                                          data[current][
                                            'price_watch_details'
                                          ][0]['pricing']
                                        "
                                      >
                                        <q-list>
                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['pricing'] = 'Premium'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Premium</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>
                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['pricing'] = 'Cheapest'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Cheapest</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>

                                          <q-item
                                            clickable
                                            v-close-popup
                                            @click="
                                              data[current][
                                                'price_watch_details'
                                              ][0]['pricing'] = 'Average'
                                            "
                                          >
                                            <q-item-section>
                                              <q-item-label
                                                >Average</q-item-label
                                              >
                                            </q-item-section>
                                          </q-item>
                                        </q-list> </q-btn-dropdown
                                      ><label>Competitor.</label>
                                     
                                    </div>
                                  </div>
                                </div>
                              </q-card-section>

                              <q-card-actions >
                                <q-btn
                                  flat
                                  style="    position: relative;right:272px;display: none;"
                                  label="Confirm"
                                  color="primary"
                                  v-close-popup
                                ></q-btn>
                              </q-card-actions>
                            </q-card>
                          </div>
                          <q-dialog
                            v-model="basic"
                            transition-show="rotate"
                            transition-hide="rotate"
                          >
                            
                          </q-dialog>
                         
                        </div>
                        
                      </div>
                    </q-card-section>

                    <q-separator></q-separator>

                    <q-card-actions >
                      <q-btn
                        :props="props"
                        v-on:click="editDetails(data[current], props.row)"
                        flat
                        label="Submit"
                        color="primary"
                        id="modal1"
                        v-close-popup="popUp"
                      ></q-btn>
                    </q-card-actions>
                  </q-card>
                </q-dialog>
                <q-dialog v-model="disable_popup">
                  <q-card>
                    <q-card-section>
                      <div class="text-h6">Alert</div>
                    </q-card-section>

                    <q-card-section class="q-pt-none">
                      Please Enable the product to continue ...
                    </q-card-section>

                    <q-card-actions >
                      <q-btn
                        flat
                        label="OK"
                        color="primary"
                        v-close-popup
                      ></q-btn>
                    </q-card-actions>
                  </q-card>
                </q-dialog>
              </q-td>
              <q-td key="delete" :props="props">
                <div v-if="props.row.is_enable === 'True'">
                  <q-btn
                    v-on:click="disability(props.row)"
                    unelevated
                    color="red"
                    label="Disable"
                    size="12px"
                  ></q-btn>
                </div>
                <div v-else>
                  <q-btn
                    v-on:click="enability(props.row)"
                    unelevated
                    color="green"
                    label="Enable"
                    size="12px"
                  ></q-btn>
                </div>
              </q-td>

              <q-td key="delete_item" :props="props">
                <div v-if="props.row.is_delete === true"></div>
                <div v-else>
                  <q-btn
                    v-on:click="deleteItem(props.row)"
                    unelevated
                    color="red"
                    label="Delete"
                    size="12px"
                  ></q-btn>
                </div>
              </q-td>
            </q-tr>
          </template>
        </q-table>

  
      </div>

    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
// import { skipValidation } from "yargs";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      editing: false,
      isAuthenticated: false,
      editibility: true,
      disable_popup: false,
      basic: false,
      filter: "",
      current: 0,
      backupList: [],
      columns: [
        {
          name: "name",
          required: true,
          label: "Product Name",
          field: "name",
          align: "left",
        },
        //  {
        //     name: 'brand',
        //     field:'brand',
        //     label: 'Brand',
        // },
        {
          name: "lower_limit",
          field: "lower_limit",
          label: "Lower Boundary",
          align: "center",
        },
        {
          name: "upper_limit",
          field: "upper_limit",
          label: "Upper Boundary",
          align: "center",
        },
       
        {
          name: "competitors_tracked",
          field: "competitors_tracked",
          label: "Competitors Tracked",
          align: "center",
        },
       
        {
          name: "edit",
          field: "edit",
          label: "Edit details",
          align: "left",
        },
        {
          name: "delete",
          field: "delete",
          label: "Enable",
          align: "left",
        },
        {
          name: "delete_item",
          field: "delete_item",
          label: "Delete",
          align: "left",
        },
      ],
      rows: [],
      data: [],
      tags: [],
      activeTag: null,
      exp: [],
      src: "drag-drop.webp",
      is_empty: true,
      max_urls: false,
      enabled: true,
      list2: [],
      tagValue: "",

      popUp: true,
    };
  },
  mounted() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/resultshistory");
        this.isAuthenticated = true;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/resultshistory");
        this.isAuthenticated = true;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
     else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
  },
  created() {
    var resultshistoryURL = this.api_url + "/resultshistory/pricewatchresults/" + this.$org_id.label;
    this.$http
      .get(resultshistoryURL)
      .then((response) => {
        let result = response.data;
        // console.log(response.data);
        let data = result.map((items) => {
          return {
            ...items,
            //jobnum: count++
          };
        });
        let count = data.length;
        this.last_data = data.length;
        //const sortedData = data.slice().sort(function(a,b){let c = new Date(a.insert_time_stamp); let d = new Date(b.insert_time_stamp); return c-d});
        const sortedData = data
          .slice()
          .sort(function(a, b) {
            let c = new Date(a.insert_time_stamp);
            let d = new Date(b.insert_time_stamp);
            return d - c;
          })
          .map((items) => {
            return {
              ...items,
            };
          });
        console.log("sortedData");
        console.log(sortedData);
        this.data = sortedData;
        this.backupList = sortedData;
        this.isLoading = false;
        this.rows = this.data;
        console.log(this.rows);
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        // console.log(err);
      });
  },
  computed: {
    hide_bgimage() {
      console.log(this.list2.length);
      if (this.list2.length == 5) {
        this.max_urls = true;
        this.enabled = false;
      }
      if (this.list2.length < 5) {
        this.max_urls = false;
        this.enabled = true;
      }
      if (this.list2.length > 5) {
        this.list2.pop();
      }
      if (this.list2.length != 0) {
        this.is_empty = false;
      } else {
        this.is_empty = true;
      }
      return "";
    },
  },
  methods: {
    hide1: function() {
      this.popUp = false;
      console.log("popup" + thispopUp);
    },



    pricevalidation(a, b) {
      a = Number(a);
      b = Number(b);
      console.log("upper" + a);
      console.log("lower" + b);
      let flag = 0;
      if (a <= 0 || b <= 0) {
        this.$q.notify({
          message: "Please enter valid numbers in upper and lower boundary",
          color: "grey-3",
          textColor: "red",
        });
        return (flag = 1);
      } else if (a < b) {
        this.$q.notify({
          message: "Upper boundary should not be less than lower boundary",
          color: "grey-3",
          textColor: "red",
        });
        return (flag = 1);
      } else if (b > a) {
        console.log("enterd2");
        this.$q.notify({
          message: " Upper boundary should not be less than lower boundary ",
          color: "grey-3",
          textColor: "red",
        });
        return (flag = 1);
      }
      return flag;
    },

    InputValidation(url, yurl, prod, status, type) {
      console.log("ENTERED vALID");
      console.log("url" + url);
      console.log(yurl);
      console.log(prod);
      console.log(type);
      let flag = 0;

      if (type != "auto_suggest") {
        console.log("BASIC CHEKC");
        if (prod == "" || yurl == "" || url == "") {
          console.log("IF CONDTION");
          this.$q.notify({
            message: " Empty fields not allowed ",
            color: "grey-3",
            textColor: "red",
          });
          return (flag = 1);
        }
      } else if (type == "auto_suggest") {
        console.log("autosuggest");
        if (prod == "" || yurl == "") {
          this.$q.notify({
            message: " Empty fields not allowed ",
            color: "grey-3",
            textColor: "red",
          });
          return (flag = 1);
        }
      }


      return flag;
    },


     

    validate(url) {
      var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (pattern.test(url)) {
        //  alert("Url is valid");
        return true;
      }
      // alert("Url is not valid!");
      return false;
    },
    addTag(arr) {
      console.log("HELLO WORLD");
      console.log(arr);
      console.log(this.tagValue);
      console.log(arr.length);
     
      //  }

      if (arr.length == 5) {
        console.log("HERE ENTERED");
        this.$alert(
          "Maximum URLs reached, only 5 competitors can be added ",
          "Sorry!",
          "error"
        );
        //  alert("Maximum URLs reached, only 5 competitors can be added");
        this.tagValue = "";
        return;
      }
      if (this.tagValue != "" && this.validate(this.tagValue)) {
        arr.push(this.tagValue);
        this.tagValue = "";
      } else {
        console.log("entered ELSE");
        this.$alert("Please enter proper url and try again", "Error", "error");
      }
    },
    removeTag(index, arr) {
      console.log("CHECK INDEX" + index);
      arr.splice(index, 1);
    },

    searchHandler(value) {
      console.log("value" + value);
      if (value.length >= 1) {
        let searchResult = this.backupList.filter((item) => {
          return item.price_watch_details[0]["product_name"].includes(
            value.toUpperCase()
          );
        });
        this.data = searchResult;
        console.log("search result" + this.data);
      } else {
        this.data = this.backupList;
        console.log("data" + this.data);
      }
    },
    disability(row) {
      console.log(row);
      row["is_enable"] = "False";
      var postURL = this.api_url + `/products/edit_enability`;
      this.$http.put(postURL, [row]).then((response) => {
        if (response.data) {
         
          console.log("Enabled");
        }
      });
    },
    enability(row) {
      console.log(row);
      row["is_enable"] = "True";
      var postURL = this.api_url + `/products/edit_enability`;
      this.$http.put(postURL, [row]).then((response) => {
        if (response.data) {
         
          console.log("Enabled");
        }
      });
    },
    deleteItem(row) {
      this.$confirm("You won't be able to revert this!", "Are you sure?").then(
        (result) => {
          if (result) {
            console.log(row);
            row["is_delete"] = "True";
            var postURL = this.api_url + `/products/edit_enability`;
            this.$http.put(postURL, [row]).then((response) => {
              if (response.data) {
                // this.$q.notify({
                // //   message: "data Changed successfully",
                // //   color: "grey-3",
                // //   textColor: "blue",
                // });
                console.log("Deleted");
              }
            });
            this.$alert("selected data has been deleted.", "Deleted!");
          }
          //do something...
        }
      );
    },
    edit(row) {
      console.log(this.data.indexOf(row));
      this.editing = true;
      this.current = this.data.indexOf(row);
    },
    editDetails(details) {
      console.log(details);
      console.log(
        "logging" + details["price_watch_details"][0]["product_lower_limit"]
      );
      console.log(
        "URL AND TAG " + details["price_watch_details"][0]["url_list"]
      );
      console.log(details.status + details.type);

      let test = this.pricevalidation(
        details["price_watch_details"][0]["product_upper_limit"],
        details["price_watch_details"][0]["product_lower_limit"]
      );
      let test2 = this.InputValidation(
        details["price_watch_details"][0]["url_list"],
        details["price_watch_details"][0]["client_url"],
        details["price_watch_details"][0]["product_tags"],
        details.status,
        details.type
      );
      console.log(test2);
      console.log("details: ", [details]);
      // console.log("flag "+test);

      var postURL = this.api_url + `/products/edit_price`;
      if (test == 0 && test2 == 0) {
        this.popUp = true;
        this.$http.put(postURL, [details]).then((response) => {
          if (response.data) {
            this.$q.notify({
              message: "data Changed successfully",
              color: "grey-3",
              textColor: "blue",
            });
            
          }
        });
      } else {
        // $refs.modal1.hide();
        this.popUp = false;
      }
    },
    edit_competitor_urls(props_row, list, url_list) {
      console.log("selected", props_row);
      console.log("all urls", url_list);
      this.$q.loading.show({
        message: "submitting your request, please wait..",
      });
      props_row.price_watch_details[0].url_list = list;
      props_row.status = "CONFIRMED";
      var postURL = this.api_url + `/products/edit_competitors_urls`;
      this.$http
        .put(postURL, [props_row])
        .then((response) => {
          if (response.data) {
            this.$q.loading.hide();
            this.$alert(
              "Competitors url updated successfully",
              "Great",
              "success"
            );
          }
        })
        .catch((err) => {
          this.$alert("Could not update Competitors url", "Sorry", "error");
        });

      // ])
      // if ( data[current]['price_watch_details'][0][
      //                           'product_lower_limit'
      // ]>data[current]['price_watch_details'][0][
      //                           'product_upper_limit']) {
      //                             this.$alert("Upper boundary lower than lower boundary");

      // }
    },
    log: function(evt) {
      window.console.log(evt);
    },
  },
}

</script>
<style scoped>
/* .editdetails{
    width:100rem;
} */

.tags-input-container {
  width: 550px;
  max-width: 704px;
  height: 120px;
  border: 1px solid #9597a6;
  border-radius: 5px 5px 5px 5px;
  overflow: scroll;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 8px;
  font-size: 12px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
.tag {
  word-break: break-word;
  padding: 2px 10px;
  margin-bottom: 8px;
  background-color: whitesmoke;
  border-radius: 8px;
}
.headi {
  font-size: 40px;
  text-align: center;
  color: rgb(33, 103, 233);
  font-family: "Lobster", cursive;
  font-weight: bold;
}
.top {
  width: 50%;
  border: 2px solid rgb(7, 112, 182);
  margin: auto;
  background-color: rgb(7, 112, 182);
  border-radius: 10px;
  font-size: 1.2rem;
  color: white;
  font-family: "Baloo 2", cursive;
  padding: 2px;
}
.details {
  /*  border:2px solid green ;  */
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: auto;
  margin-top: 2rem;
  padding: 0 3rem;
  border-radius: 10px;
  background-color: rgb(210, 230, 250); /*rgb(210, 230, 250)  */
}
.lab {
  width: 37%;
  display: flex;
  flex-direction: column;
  /*  border:1px solid red ;  */
  padding: 2px;
}
.lab label {
  font-size: 1.3rem;
  padding: 0.15rem;
  font-family: "Baloo 2", cursive;
}
.inp {
  width: 63%;
  display: flex;
  flex-direction: column;
  /*  border:1px solid red ;  */
}
.inp input {
  margin-bottom: 5px;
  height: 2rem;
  border-radius: 10px;
  border: 0px solid blue;
}
.types {
  width: 60%;
  margin: auto;
  padding: 4px;
  font-size: 1.3rem;
  font-family: "Baloo 2", cursive;
  background-color: rgb(210, 230, 250);
}
#q-app {
  margin-top: 3rem;
  border-radius: 10px;
  box-shadow: 5px 5px 5px 5px rgb(0 0 0 / 30%);
}
.q-table__control {
  margin-right: 100px !important;
  position: relative;
  left: 4vh;
  -webkit-text-stroke-width: medium;
}
.q-table__title {
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 800;
}
.q-table__container {
  border-radius: 10px;
}
.q-tr {
  font-weight: bold;
}
.q-btn {
  background-color: rgb(114, 151, 221);
}
.q-focus-helper {
  font-size: 12px;
}
.q-radio__inner::before {
  font-size: 20px;
}
.title1 {
  position: relative;
  left: 2%;
  -webkit-text-stroke-width: medium;
}
.moving-card {
  opacity: 0.8;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.list-group {
  min-height: 53vh;
}
.list-group-item {
  margin: 10px 5px;
  min-height: 50px;
  border-radius: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 9px;
  cursor: grab;
}
/* 
.left-draggable{
  background-image: url("../../assets/drag-drop.webp");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
} */
.list-group-item p {
  margin: 0;
}
.left-list {
  border-left: 4px solid #68d391;
}
.right-list {
  border-left: 4px solid #f6e05e;
}
.scroll {
  position: relative;
}
.submit {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: #f7fafc;
}
.q-card {
  border-radius: 20px;
}
.left-draggable {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}
.left-draggable img {
  object-fit: cover;
  width: 95%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
.left-draggable .left-group {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 0;
}
.left-draggable .note {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.7;
  font-size: 18px;
  top: 77%;
  letter-spacing: 1px;
}
.right-draggable {
  max-height: 52.5vh;
  overflow-y: scroll;
}
.close-icon {
  font-size: 32px;
  cursor: pointer;
}
.close-icon:hover {
  color: rgb(255, 5, 5) !important;
}
.autogenerate {
  color: #2166b1;
}
.q-btn {
  width: 110px !important ;
}
.check {
  visibility: hidden;
}
.text-h6 {
  font-family: sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
}
.lab label[data-v-2afb717e] {
  font-size: 1.5rem;
  padding: 1rem;
  font-family: ui-sans-serif;
  font-weight: 547;
}
.details-row {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.form-control {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.form-control-text-area {
  width: 100%;
}

.form-control-text-area {
  width: 100%;
}

.form-control-text-area {
  width: 100%;
}
.form-control-text-area {
  width: 100%;
}

.form-control-text-area {
  width: 100%;
}
.form-control-text-area {
  width: 100%;
}

.form-control label,
.form-control input {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
}

.form-control label {
  font-size: 1.25rem;
  font-family: "Times New Roman", Times, serif;
  margin-bottom: 10px;
  width: 100%;
  height: 28px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #9597a6;
}

.form-control input {
  padding: 0.8rem;
  border-radius: 17px;
  width: 33rem;
}

.form-control-text-area textarea {
  width: 100%;
  margin: 0.5rem;
  padding: 1rem;
}
.form-control label {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: bold;
}
/* .form-control {
  width: 43rem;
} */
.inputs {
  padding-left: 86px;
}
.block {
  color: #f7fafc;
}
.form-control label[data-v-2afb717e] {
  border: none;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: bold;
}
.tags-input-container[data-v-2afb717e] {
  width: 550px;
  max-width: 704px;
  height: 120px;
  border: 1px solid #9597a6;
  border-radius: 5px 5px 5px 5px;
  overflow: scroll;


  overflow-y: visible;


  overflow-y: visible;

  overflow-y: scroll;
  overflow-x: hidden;
  padding: 8px;
  font-size: 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border: none;
}

</style>

</style>

